import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@trellis/roots/select'

import { useTermsTemplatesQuery } from '@/hooks/useTermsTemplates'

interface TermsTemplatePickerProps {
  onSelect: (body: string) => void
}

export function TermsTemplatePicker({ onSelect }: TermsTemplatePickerProps) {
  const { data: termsTemplates = [] } = useTermsTemplatesQuery()

  if (termsTemplates.length === 0) return null

  return (
    <Select
      value=""
      onValueChange={(id) => {
        const template = termsTemplates.find((candidate) => candidate.id === id)
        if (template) onSelect(template.body)
      }}
    >
      <SelectTrigger
        aria-label="Load from template"
        className="h-7 w-auto gap-1.5 border-none bg-transparent px-2 text-xs shadow-none"
      >
        <SelectValue placeholder="Load from template" />
      </SelectTrigger>
      <SelectContent>
        {termsTemplates.map((template) => (
          <SelectItem key={template.id} value={template.id}>
            {template.name}
            {template.isDefault ? ' (default)' : ''}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
